/**
 * FF Product Card Video Custom Element
 * Plays the card's secondary media (video) on hover instead of on page load.
 *
 * The <video> keeps preload="none" and no autoplay attribute, so the browser
 * fetches nothing until .play() is called here - zero network cost per card
 * until real hover intent, even in a grid with dozens of products.
 */

class FFProductCardVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    this.card = this.closest('.ff-product-card');
    if (!this.card) return;

    this.handleEnter = this.handleEnter.bind(this);
    this.handleLeave = this.handleLeave.bind(this);
    this.card.addEventListener('mouseenter', this.handleEnter);
    this.card.addEventListener('mouseleave', this.handleLeave);
  }

  disconnectedCallback() {
    if (!this.card) return;
    this.card.removeEventListener('mouseenter', this.handleEnter);
    this.card.removeEventListener('mouseleave', this.handleLeave);
  }

  handleEnter() {
    const playback = this.video.play();
    if (playback && typeof playback.catch === 'function') {
      playback.catch(function () {});
    }
  }

  handleLeave() {
    this.video.pause();
  }
}

if (!customElements.get('ff-product-card-video')) {
  customElements.define('ff-product-card-video', FFProductCardVideo);
}
